import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

const NotFoundPage = () => {
  return (
    <main style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center', padding: '48px' }}>
        <h1 className="display-large" style={{ marginBottom: '16px' }}>404</h1>
        <h2 className="heading-1" style={{ marginBottom: '24px' }}>Page Not Found</h2>
        <p className="body-medium" style={{ marginBottom: '32px', maxWidth: '400px' }}>
          Sorry, the page you’re looking for doesn’t exist or has been moved.
        </p>
        <div style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>
          <Link to="/" className="btn-primary">
            <Home size={18} style={{ marginRight: '8px' }} />
            Go Home
          </Link>
          <button onClick={() => window.history.back()} className="btn-secondary">
            <ArrowLeft size={18} style={{ marginRight: '8px' }} />
            Go Back
          </button>
        </div>
      </div>
    </main>
  );
};

export default NotFoundPage;
